import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaUtensils } from "react-icons/fa";
import { Link } from "react-router-dom";
import ChatbotCartButton from "~/cart/Components/CartButton";
import LoadingSpinner from "~/components/ui/LoadingSpinner";
import { useBranch } from "~/contexts/BranchContext";
import ModernMenuPage from "~/templates/modern/menu/ModernMenuPage";
import type { MenuItem } from "~/types/new_types";
import NotFoundPage from "../not-found/NotFoundPage";
import Footer from "~/components/layout/Footer";
import { useShoppingCart } from "~/contexts/ShoppingCartContext";
import { useState } from "react";
import AnnouncementModal from "~/components/modal/AnnouncementModal";

export type DietaryFilters = {
  vegetarian: boolean;
  vegan: boolean;
  glutenFree: boolean;
};

const MenuPage = () => {
  const { t } = useTranslation();
  const { branchData, isLoading, error, isAgentActive, setSelectedItem } =
    useBranch();
  const { tempQuantities } = useShoppingCart();
  const totalCartItems = Object.values(tempQuantities).filter(
    (item) => item.quantity > 0
  ).length;
  const handleChatbotItemClick = (item: MenuItem) => {
    setSelectedItem(item);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size={4} message={t("restaurant.loading")} />
      </div>
    );
  }

  if (error || !branchData) {
    return <NotFoundPage />;
  }

  return (
    <>
      <AnnouncementModal />
      <ModernMenuPage />

    </>
  );};

export default MenuPage;
